export const AZURE_PROJECTS_MODEL = {
  NAME: 'name',
  LAST_ACTIVITY: 'last_activity',
  ASSIGNEES: 'assignees',
  EPICS_COUNT: 'associated_count',
  EFFORT: 'effort_p',
  EFFORT_FTE: 'effort_fte',
  ISSUES_WITH_NO_EPICS: 'issues_with_no_epics',
  URL: 'url'
};

export const AZURE_EPICS_MODEL = {
  NAME: 'name',
  ASSIGNEES: 'assignees',
  FEATURES: 'associated_count',
  EFFORT: 'effort_p',
  EFFORT_FTE: 'effort_fte',
  URL: 'url'
};

export const AZURE_FEATURES_MODEL = {
  NAME: 'name',
  ASSIGNEES: 'assignees',
  WORK_ITEMS_COUNT: 'associated_count',
  EFFORT: 'effort_p',
  EFFORT_FTE: 'effort_fte',
  STATUS: 'status',
  URL: 'url'
};

export const AZURE_TAGS_MODEL = {
  NAME: 'name',
  ASSIGNEES: 'assignees',
  WORK_ITEMS_COUNT: 'associated_count',
  EFFORT: 'effort_p',
  EFFORT_FTE: 'effort_fte',
  STATUS: 'status',
  URL: 'url'
};

export const AZURE_CUSTOM_FIELD_MODEL = {
  NAME: 'name',
  ASSIGNEES: 'assignees',
  WORK_ITEMS_COUNT: 'associated_count',
  EFFORT: 'effort_p',
  EFFORT_FTE: 'effort_fte',
  STATUS: 'status',
  URL: 'url'
};

export const TABLE_MODEL_AZURE_PROJECTS = {
  NAME_CELL: 'azure_name_cell',
  LAST_ACTIVITY_CELL: 'azure_last_activity_cell',
  ASSIGNEES_CELL: 'azure_assignees_cell',
  EPICS_COUNT_CELL: 'azure_associated_count_cell',
  EFFORT_CELL: 'azure_effort_cell',
  EFFORT_FTE_CELL: 'azure_effot_fte_cell',
  ISSUES_WITH_NO_EPICS_CELL: 'azure_issues_with_no_epics_cell',
  COST_FTE_CELL: 'azure_cost_fte_cell'
};

export const TABLE_MODEL_AZURE_EPICS = {
  NAME_CELL: 'name_cell',
  ASSIGNEES_CELL: 'assignees_cell',
  FEATURES_CELL: 'features_cell',
  EFFORT_CELL: 'effort_cell',
  EFFORT_FTE_CELL: 'effot_fte_cell',
  COST_FTE_CELL: 'cost_fte_cell'
};

export const TABLE_MODEL_AZURE_FEATURES = {
  NAME_CELL: 'name_cell',
  ASSIGNEES_CELL: 'assignees_cell',
  WORK_ITEMS_COUNT_CELL: 'work_items_count_cell',
  EFFORT_CELL: 'effort_cell',
  EFFORT_FTE_CELL: 'effot_fte_cell',
  COST_FTE_CELL: 'cost_fte_cell'
};

export const TABLE_MODEL_AZURE_TAGS = {
  NAME_CELL: 'name_cell',
  ASSIGNEES_CELL: 'assignees_cell',
  WORK_ITEMS_COUNT_CELL: 'work_items_count_cell',
  EFFORT_CELL: 'effort_cell',
  EFFORT_FTE_CELL: 'effot_fte_cell',
  COST_FTE_CELL: 'cost_fte_cell'
};

export const TABLE_MODEL_AZURE_CUSTOM_FIELD = {
  NAME_CELL: 'name_cell',
  ASSIGNEES_CELL: 'assignees_cell',
  WORK_ITEMS_COUNT_CELL: 'work_items_count_cell',
  EFFORT_CELL: 'effort_cell',
  EFFORT_FTE_CELL: 'effot_fte_cell',
  COST_FTE_CELL: 'cost_fte_cell'
};
